// extracted by mini-css-extract-plugin
export var customTooltip = "DataGrid-module--custom-tooltip--5q-QN";
export var dot = "DataGrid-module--dot--JKV8F";
export var padding2 = "DataGrid-module--padding-2--bJsBH";
export var paddingLeft2 = "DataGrid-module--padding-left-2--IAUtg";